export const columnFields = [
	'name',
	'status',
	'email',
	'lastActivityAt',
	'skills',
	'scopes',
	'teams',
	'workload',
	'productivity.latestScore',
	'canAccessPlatform',
] as const;

export const adminColumnFields = [
	'name',
	'email',
	'canAccessPlatform',
	'lastActivityAt',
	'scopes',
	'teams',
] as const;

// oxlint-disable-next-line no-unused-vars
type _AdminColumnFieldsSafetyNet<
	T extends (typeof columnFields)[number] = (typeof adminColumnFields)[number],
> = T;

export const estimatorColumnFields = [
	'name',
	'status',
	'skills',
	'teams',
	'workload',
	'productivity.latestScore',
] as const;

// oxlint-disable-next-line no-unused-vars
type _EstimatorColumnFieldsSafetyNet<
	T extends (typeof columnFields)[number] = (typeof estimatorColumnFields)[number],
> = T;

export const listColumnFields = ['name'] as const;

// oxlint-disable-next-line no-unused-vars
type _ListColumnFieldsSafetyNet<
	T extends (typeof columnFields)[number] = (typeof listColumnFields)[number],
> = T;
